export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('Dropdown', (options, excludeOptions = null, inicialValue=null) => {
        let originalOptions = options;

        // transform the options to an array of objects
        originalOptions = Object.entries(originalOptions)
          .map(([key, optionValue]) => ({
            id: key,
            value: optionValue,
          }))
          .filter((option) => {
            if (!excludeOptions) return true;
            const excludedOption = excludeOptions.find((excluded) => {
              return excluded.toLowerCase() === option.value.toLowerCase();
            });

            if (excludedOption) {
              return false;
            }
            return true;
          });
        // clean up the invalid option
        originalOptions = originalOptions.filter((option) => option.id !== '');

        return {
          displayOptions: false,
          value: inicialValue,
          filteredOptions: [...originalOptions],
          toggleDropdown() {
            this.displayOptions = !this.displayOptions;
          },
          selectOption(option) {
            if (this.value === option) {
              this.value = null;
              this.displayOptions = false;
              return;
            }
            this.value = option;
            this.displayOptions = false;
          },
          filterOptions(value) {
            const newOptions = [...originalOptions];
            try {
              if (!value) {
                this.filteredOptions = newOptions;
                return;
              }
              this.filteredOptions = newOptions.filter((option) =>
                option.value.toLowerCase().includes(value.toLowerCase()),
              );
            } finally {
              if (this.filteredOptions.length === 0) {
                this.filteredOptions = [
                  {
                    id: 'error',
                    value: 'oops... no states matches!',
                  },
                ];
              }
            }
          },
        };
      });
    });
  },
};
